import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';

class ArchiveConfirmationDialog implements ng.IController {

    public title: string;
    public message: string;
    public accounts: string[];
    public modalInstance: ng.ui.bootstrap.IModalInstanceService = this as any;

    private resolve: {
        title: string;
        message: string;
        accounts: string[];
    };

    public async $onInit() {
        this.title = this.resolve.title;
        this.message = this.resolve.message;
        this.accounts = this.resolve.accounts;
    }

    public closeDialog() {
        this.modalInstance.close({ $value: false });
    }

    public confirm() {
        this.modalInstance.close({ $value: true });
    }
}

angular.module('naut').component('archiveConfirmationDialog', {
    template: require('./archive-confirmation-dialog.component.html'),
    controller: ArchiveConfirmationDialog,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/jispPay/components/jispPayStaff/archive-confirmation-dialog/archive-confirmation-dialog.component.ts